module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "add-delivery-address"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("orders.deliveryAddress.TitleAdd")))]), _vm._v(" "), _c('div', {
    staticClass: "add-delivery-address-textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.deliveryAddressContent),
      expression: "deliveryAddressContent",
      modifiers: {
        "trim": true
      }
    }],
    key: _vm.action.id,
    class: {
      empty: _vm.error
    },
    attrs: {
      "rows": "4",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.deliveryAddressContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryAddressContent = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-client",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-client",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deliveryAdressAdd();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.deliveryAddress.btnAdd")))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fc54ca1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/actions/AddDeliveryAddress.vue
// module id = 3016
// module chunks = 0